(function() {
	angular.module('pphhApp')
		.service("gisActionController", ["GisService", "$window", "$mdDialog", GisActionController]);

	/**
	 * Componente que gestiona la acción de localizar una determinada instancia en el visor 
	 * geográfico.
	 */
	function GisActionController(gisService, $window, $mdDialog) {

		this.performAction = performAction;

		function performAction(scope, row) {
			if (scope.entity.entityName === "surfacewb") {
				gisService.openSurfaceWaterBodyViewer(row.id);

			} else if (scope.entity.entityName === "groundwb") {
				gisService.openGroundWaterBodyViewer(row.id);

			} else if (scope.entity.entityName === "medidas") {
				gisService.openMeasureViewer(row.id);

			} else if (scope.entity.entityName === "rbd") {
				gisService.openRbdViewer(row.id);

			} else if (scope.entity.entityName === "surfacewbassoprotarea") {
				gisService.openSurfaceProtectedAreaViewer(row.id);

			} else if (scope.entity.entityName === "gwbassocpa") {
				gisService.openGroundProtectedAreaViewer(row.id);

			} else if (scope.entity.entityName === "monisite") {
				gisService.openMonitoringSiteViewer(row.id);

			} else if (scope.entity.entityName === "uwwagglomerations") {
				gisService.openAgglomerationViewer(row.id);

			} else if (scope.entity.entityName === "uwwtp") {
				gisService.openTreatmentPlanViewer(row.id);

			} else if (scope.entity.entityName === "uwwdischargePoints") {
				gisService.openDischargePointViewer(row.id);

			} else if (scope.entity.entityName === "catamasa") {
				// Obtenemos el tipo de masa de agua y el identificador dentro de la tabla correspondiente
				gisService.getDmaWaterbody (row.id).then(function(data) {
					if (data.tipo === "surfacewb") {
						gisService.openSurfaceWaterBodyViewer(data.id);
					} else if (data.tipo === "groundwb") {
						gisService.openGroundWaterBodyViewer(data.id);
					}
				});
			} else if (scope.entity.entityName === "nidGwStat" || scope.entity.entityName === "nidSwStat") {
				// Obtenemos el tipo de masa de agua y el identificador dentro de la tabla correspondiente
				if (row.euCd !== undefined){
					gisService.getNidMonitoringSite (row.euCd, scope.cicloId).then(function(data) {
						if (data.id != null){
							gisService.openMonitoringSiteViewer(data.id);
						} else{
							$mdDialog.show(
									$mdDialog.alert({
										title: UIMessages.dialog.confirm.title,
										textContent: UIMessages.visor.invalidStationCode,
										ok: UIMessages.dialog.confirm.cerrar
									}));
						}

					});
				}
			} else if (scope.entity.entityName === "nidNvzboundaries") {
				gisService.openNitratesViewer(row.id);
			}
			$window.scroll(0, 0);
		}
	}

})();